/** Development Express — Excel report theme & layout tokens */

import { safeMerge, initMergeTracker, flushMergeReports } from './mergeHelper';

export { initMergeTracker, safeMerge, flushMergeReports };

export const DE_EXCEL = {
  company: 'Development Express',
  tagline: 'Heavy Equipment Rental · Since 2011',
  module: 'Development Express Finance Module',
  fonts: {
    title: 'Segoe UI',
    body: 'Calibri',
    mono: 'Consolas',
  },
  layout: {
    rowCompact: 16,
    rowHeader: 20,
    rowBanner: 22,
    rowKpi: 18,
    defaultZoom: 90,
  },
  colors: {
    navy: 'FF0A1628',
    navyLight: 'FF122A4A',
    navyMid: 'FF1E3A5F',
    gold: 'FFC9A84C',
    goldLight: 'FFF5E6B8',
    goldDim: 'FF8A6420',
    white: 'FFFFFFFF',
    muted: 'FF64748B',
    credit: 'FF047857',
    creditBg: 'FFD1FAE5',
    creditText: 'FF065F46',
    debit: 'FFDC2626',
    debitBg: 'FFFEE2E2',
    debitText: 'FF991B1B',
    zebra: 'FFF1F5F9',
    zebraAlt: 'FFE2E8F0',
    border: 'FFCBD5E1',
    borderDark: 'FF94A3B8',
    headerBg: 'FF0F2038',
    summaryBg: 'FF1E293B',
    success: 'FF059669',
    successBg: 'FFECFDF5',
    warning: 'FFD97706',
    warningBg: 'FFFFFBEB',
    danger: 'FFDC2626',
    dangerBg: 'FFFEF2F2',
    link: 'FF2563EB',
    watermark: 'FFF1F5F9',
    healthGood: 'FF10B981',
    healthWarn: 'FFF59E0B',
    healthBad: 'FFEF4444',
  },
};

/** Indian accounting: positives, red negatives in parentheses, dash for zero */
export const INR_ACCOUNTING = '"₹"#,##0.00_);[Red]("[₹"#,##0.00);[Color7]"-"';
export const INR_NUMFMT = INR_ACCOUNTING;
export const INR_NUMFMT_INT = '#,##0_);[Red](#,##0);[Color7]"-"';
export const PCT_NUMFMT = '0.0%';

export function colLetter(n) {
  let letter = '';
  let num = n;
  while (num > 0) {
    const mod = (num - 1) % 26;
    letter = String.fromCharCode(65 + mod) + letter;
    num = Math.floor((num - 1) / 26);
  }
  return letter;
}

export function mergeRange(sheet, c1, r1, c2, r2, label = '') {
  if (!sheet.__deMergeTracker) initMergeTracker(sheet, { sheetName: sheet.name });
  return safeMerge(sheet, c1, r1, c2, r2, label);
}


export function fillSolid(argbColor) {
  return { type: 'pattern', pattern: 'solid', fgColor: { argb: argbColor } };
}

export function thinBorder(color = DE_EXCEL.colors.border) {
  const side = { style: 'thin', color: { argb: color } };
  return { top: side, left: side, bottom: side, right: side };
}

export function mediumBorder(color = DE_EXCEL.colors.borderDark) {
  const side = { style: 'medium', color: { argb: color } };
  return { top: side, left: side, bottom: side, right: side };
}

export function formatRangeLabel(from, to) {
  if (from && to) return `${from} to ${to}`;
  if (from) return `From ${from}`;
  if (to) return `Until ${to}`;
  return 'All dates';
}

export function formatGeneratedAt() {
  return new Date().toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}
